import {
    getEvelinOrderIdStorage,
    getPaymentTransactionIdStorage,
    getPaypalOrderIdStorage,
    getPersonalInfoStorage,
    type PersonalInformation,
} from '@jsmdg/browser-storage';
import { type PersonalInfo } from '../types/paypalTypes';

function saveCheckoutInformationInSession({
    evelinOrderId,
    paypalOrderId,
    personalInformation,
    paymentTransactionId,
}: {
    evelinOrderId: string;
    paypalOrderId?: string;
    personalInformation: PersonalInfo;
    paymentTransactionId?: string;
}): void {
    getEvelinOrderIdStorage().set(evelinOrderId);
    getPersonalInfoStorage().set(personalInformation as PersonalInformation);
    if (paypalOrderId) {
        getPaypalOrderIdStorage().set(paypalOrderId);
    }

    if (paymentTransactionId) {
        getPaymentTransactionIdStorage().set(paymentTransactionId);
    }
}

export { saveCheckoutInformationInSession };
